import { createAction, props } from '@ngrx/store'
import { NavigationExtras } from '@angular/router'

export const navigate = createAction('[Router] Navigate', props<{ path: string; extras?: NavigationExtras }>())
export const goToPage = createAction('[Router] Go to page', props<{ page?: string }>())
export const navigateExternal = createAction('[Router] Navigate External', props<{ path: string }>())
export const navigateByUrl = createAction('[Router] Navigate by url', props<{ path: string }>())
export const changeLocation = createAction('[Router] Change location without navigation', props<{ path: string }>())
